import { Link, useNavigate } from '@tanstack/react-router';
import { PlusCircle } from 'lucide-react';

import { Button } from '@/_components';
import { hotKeys, useShortcutKey } from '@/_shared';
import type { ToPath } from '@/types';

export function NewButton({
  to,
  title,
  disableShortcut = false,
}: {
  to: ToPath;
  title: string;
  disableShortcut?: boolean;
}) {
  const nav = useNavigate();

  useShortcutKey(hotKeys.createNew, () => {
    if (disableShortcut) return;
    nav({ to });
  });

  return (
    <Link to={to}>
      {/* <Button icon={PlusCircle} size="sm" className={!disableShortcut ? 'pr-10' : ''}>
        {title}
        {!disableShortcut && (
          <div className="absolute right-2.5 bottom-1.75 rounded-sm border border-white/70 px-1 py-0 text-[10px] opacity-70">
            {osKey}I
          </div>
        )}
      </Button> */}
      <NewButtonUI osKey="I" disableShortcut={disableShortcut} title={title} />
    </Link>
  );
}

export function NewButtonUI({
  title,
  disableShortcut = false,
  osKey,
  onClick,
}: {
  osKey?: string;
  title: string;
  disableShortcut?: boolean;
  onClick?: () => void;
}) {
  return (
    <Button onClick={onClick} icon={PlusCircle} size="sm" className={!disableShortcut ? 'pr-10' : ''}>
      {title}
      {!disableShortcut && osKey && (
        <div className="absolute right-2.5 bottom-1.75 rounded-sm border border-white/70 px-1 py-0 text-[10px] opacity-70">
          ⌘{osKey}
        </div>
      )}
    </Button>
  );
}
